import React, { useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Layout, Users, BookOpen, MessageSquare, Zap } from 'lucide-react';

export const MobileNav = () => {
    const location = useLocation();
    const scrollRef = useRef<HTMLDivElement>(null);

    const menuItems = [
        { id: 'dashboard', label: 'Dash', icon: Layout, path: '/dashboard' },
        { id: 'personas', label: 'Personas', icon: Users, path: '/personas' },
        { id: 'contexts', label: 'Contextos', icon: BookOpen, path: '/contextos' },
        { id: 'conversations', label: 'Conversas', icon: MessageSquare, path: '/conversas' },
        { id: 'insights', label: 'Insights', icon: Zap, path: '/insights' },
    ];

    // Auto-scroll to active item
    useEffect(() => {
        const activeIndex = menuItems.findIndex(item => location.pathname.startsWith(item.path));
        if (activeIndex >= 0 && scrollRef.current) {
            const container = scrollRef.current;
            const items = container.querySelectorAll('[data-nav-item]');
            const activeItem = items[activeIndex] as HTMLElement;
            if (activeItem) {
                const containerWidth = container.offsetWidth;
                const itemLeft = activeItem.offsetLeft;
                const itemWidth = activeItem.offsetWidth;
                const scrollTo = itemLeft - (containerWidth / 2) + (itemWidth / 2);
                container.scrollTo({ left: scrollTo, behavior: 'smooth' });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    return (
        <nav className="fixed bottom-0 left-0 right-0 z-40 bg-indigo-100/95 backdrop-blur-xl border-t-2 border-indigo-200/60 shadow-[0_-8px_30px_-15px_rgba(79,70,229,0.25)] md:hidden safe-area-bottom pb-[env(safe-area-inset-bottom)]">
            {/* Fade gradient indicators */}
            <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-indigo-100/95 to-transparent z-10" />
            
            <div
                ref={scrollRef}
                className="flex items-center h-[72px] px-2 overflow-x-auto snap-x snap-mandatory scrollbar-hide"
                style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            >
                {menuItems.map(item => {
                    const isActive = location.pathname.startsWith(item.path);
                    return (
                        <Link
                            key={item.id}
                            to={item.path}
                            data-nav-item
                            className={`group flex flex-col items-center justify-center min-w-[72px] h-full snap-center active:scale-90 transition-transform duration-200 ${
                                isActive ? 'text-indigo-700' : 'text-slate-600 hover:text-indigo-700'
                            }`}
                        >
                            <div className={`p-2 rounded-full mb-1 transition-all duration-300 ease-out flex items-center justify-center ${
                                isActive 
                                    ? 'bg-indigo-600 shadow-md shadow-indigo-600/30 -translate-y-1' 
                                    : 'bg-transparent group-hover:bg-indigo-100/50'
                            }`}>
                                <item.icon 
                                    size={20} 
                                    className={`transition-colors duration-300 ${isActive ? 'stroke-[2.5px] text-white' : 'stroke-2'}`} 
                                />
                            </div>
                            
                            <span className={`text-[10px] font-medium transition-all duration-300 ${
                                isActive ? 'font-bold opacity-100 -translate-y-0.5' : 'opacity-80'
                            }`}>
                                {item.label}
                            </span>
                        </Link>
                    )
                })}
            </div>
        </nav>
    );
};
